'use strict';

(function () {
    document.addEventListener("DOMContentLoaded", () => {
        const navbar = document.querySelector(".navbar");
        const navbarNav = document.getElementById("navbarNav");

        if (navbar && navbarNav) {
            navbarNav.addEventListener("shown.bs.collapse", () => {
                navbar.classList.add("bg-expanded");
            });

            navbarNav.addEventListener("hidden.bs.collapse", () => {
                navbar.classList.remove("bg-expanded");
            });
        }
    });

    /** bootstrap dropdowns */
    document.addEventListener("DOMContentLoaded", function () {
        // -----Dropdown----------

        // Rule: link.dropdown-link data-dropdown='dropdownIdentifier' div#dropdownIdentifier
        let dropdowns = document.querySelectorAll(".dropdown-toggle");
        for (let dropdown of dropdowns) {
            dropdown.onclick = function (e) {
                let dropdownDiv =
                    dropdown.parentElement.querySelector(".dropdown-menu");

                if (!dropdownDiv) {
                    dropdownDiv = document.getElementById(
                        dropdown.getAttribute("data-dropdown")
                    );
                }

                if (dropdownDiv.style.display == "block") {
                    dropdownDiv.style.display = "none";
                } else {
                    dropdownDiv.style.display = "block";
                }
            };
        }
    });

    let menuButton = document.querySelector(".navbar-toggler");

    if (menuButton) {
        menuButton.addEventListener("click", function (event) {
            let list = document.getElementById("navbar");
            console.log(list);
            if (list.classList.contains("show")) {
                list.classList.remove("show");
            } else {
                list.classList.add("show");
            }
        });
    }
})();
